export const SALE_UPDATE_FORM_ID = Symbol();
